import api from 'services/api';

export const APPS_LIST = 'apps/list';
export const APPS_FETCH = 'apps/fetch';
export const APPS_FETCH_LINK_CANDIDATES = 'apps/fetchLinkCandidates';
export const APPS_LINK = 'apps/link';
export const APPS_DISCONNECT = 'apps/disconnect';
export const APPS_FETCH_VERSION = 'apps/fetchVersion';
export const APPS_STAGE = 'apps/stage';
export const APPS_PUBLISH = 'apps/publish';
export const APPS_UNPUBLISH = 'apps/unpublish';
export const APPS_SUBMIT_REVIEW = 'apps/submitReview';
export const APPS_CREATE_COMMENT = 'apps/createComment';
export const APPS_UPDATE_COMMENT = 'apps/updateComment';
export const APPS_DELETE_COMMENT = 'apps/deleteComment';

// The version comes from the location query
const versionUri = (id, version) =>
  `/partner/apps/${id}/versions/${encodeURIComponent(version)}`;

const actions = {
  list(query) {
    return {
      type: APPS_LIST,
      payload: api.get('/partner/apps', query),
    };
  },

  fetch(id) {
    return {
      type: APPS_FETCH,
      payload: api.get(`/partner/apps/${id}`),
    };
  },

  fetchLinkCandidates(query) {
    return {
      type: APPS_FETCH_LINK_CANDIDATES,
      payload: api.get('/partner/apps/link-candidates', query),
    };
  },

  link(appIds) {
    return {
      type: APPS_LINK,
      payload: api.post('/partner/apps/link', { app_ids: appIds }),
    };
  },

  disconnect(id) {
    return {
      type: APPS_DISCONNECT,
      payload: api.post(`/partner/apps/${id}/disconnect`),
    };
  },

  fetchVersion(id, version) {
    return {
      type: APPS_FETCH_VERSION,
      payload: api.get(versionUri(id, version)),
    };
  },

  stage(id, version) {
    return {
      type: APPS_STAGE,
      payload: api.post(`${versionUri(id, version)}/stage`),
    };
  },

  publish(id, version) {
    return {
      type: APPS_PUBLISH,
      payload: api.post(`${versionUri(id, version)}/publish`),
    };
  },

  unpublish(id, version) {
    return {
      type: APPS_UNPUBLISH,
      payload: api.post(`${versionUri(id, version)}/unpublish`),
    };
  },

  submitReview(id, version) {
    return {
      type: APPS_SUBMIT_REVIEW,
      payload: api.post(`${versionUri(id, version)}/submit-review`),
    };
  },

  comments: {
    create(id, data) {
      return {
        type: APPS_CREATE_COMMENT,
        payload: api.post(`/partner/apps/${id}/comments`, data),
      };
    },

    update(id, commentId, data) {
      return {
        type: APPS_UPDATE_COMMENT,
        payload: api.put(`/partner/apps/${id}/comments/${commentId}`, data),
      };
    },

    remove(id, commentId) {
      return {
        type: APPS_DELETE_COMMENT,
        payload: api.delete(`/partner/apps/${id}/comments/${commentId}`),
      };
    },
  },
};

export default actions;
